import { TOOL_CHECKOUTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/tool_checkouts_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'myPickupsInUseIndex',
	'myPickupsHistoryIndex',
	'toolUsageHistoryIndex',
	'woToolsIndex',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
